import { useAppStore }     from '@/tools/exmarked/stores/appStore'
import { useKeyboard }     from '@/tools/exmarked/hooks/useKeyboard'
import { TopBar }          from '@/tools/exmarked/components/layout/TopBar'
import { GlobalVault }     from '@/tools/exmarked/components/vault/GlobalVault'
import { Sidebar }         from '@/tools/exmarked/components/workspace/Sidebar'
import { MarkdownViewer }  from '@/tools/exmarked/components/viewer/MarkdownViewer'

function WorkspaceWelcome() {
  return (
    <div className="flex items-center justify-center h-full text-center p-8">
      <div className="space-y-3">
        <div className="w-10 h-10 rounded-lg border border-forge-border/50 flex items-center justify-center mx-auto">
          <svg className="w-5 h-5 text-forge-border" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <p className="text-forge-ash text-sm">
          Select a <span className="text-forge-gold font-mono text-xs">.md</span> file
          from the sidebar to begin reading.
        </p>
      </div>
    </div>
  )
}

export function ExMarkedTool() {
  const view = useAppStore((s) => s.view)

  useKeyboard()

  return (
    <div className="h-full flex flex-col bg-forge-void overflow-hidden">
      <TopBar />
      <div className="flex-1 flex overflow-hidden">
        {view !== 'vault' && <Sidebar />}
        <main className="flex-1 overflow-auto">
          {view === 'vault'     && <GlobalVault />}
          {view === 'workspace' && <WorkspaceWelcome />}
          {view === 'viewer'    && <MarkdownViewer />}
        </main>
      </div>
    </div>
  )
}
